// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8176d99a","404":"d359cc0a"}[chunkId] + ".chunk.js";
};